
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_lose_access",
      function () {
        return require("private-next-pages/_lose_access.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_lose_access"])
      });
    }
  